import { api } from './client';

export interface FourDFItem {
  individual_id: string;
  last_name: string;
  first_name: string;
  middle_name: string | null;
  full_name: string | null;
  inn: string;
  income_sign: string;
  gross_accrued: number;
  gross_paid: number;
  pdfo_accrued: number;
  pdfo_paid: number;
  wz_accrued: number;
  wz_paid: number;
  months: number;
}

export interface FourDFData {
  organization: { code: string; name: string; full_name: string; edrpou: string };
  period: { year: number; quarter: number; months: number[] };
  items: FourDFItem[];
  totals: { gross: number; pdfo: number; wz: number; employees_count: number };
}

export interface ESVItem {
  individual_id: string;
  full_name: string | null;
  inn: string;
  gross: number;
  esv: number;
  esv_rate: number;
  esv_base: number;
}

export interface ESVData {
  organization: { code: string; name: string; full_name: string; edrpou: string };
  period: { year: number; month: number };
  items: ESVItem[];
  totals: { gross: number; esv: number; employees_count: number };
}

export interface VATD1Item {
  edrpou: string;
  name: string;
  amount: number;
  vat: number;
  vat_rate: number;
}

export interface VATD1Data {
  organization: { code: string; name: string; full_name: string; edrpou: string };
  period: { year: number; month: number };
  obligations: VATD1Item[];
  credit: VATD1Item[];
}

export const taxReports = {
  get4df: (organization_id: string, period_year: number, period_quarter: number) =>
    api.get<FourDFData>('/tax-reports/4df/data', {
      params: { organization_id, period_year, period_quarter },
    }).then((r) => r.data),
  download4dfXml: (organization_id: string, period_year: number, period_quarter: number) => {
    const params = new URLSearchParams({
      organization_id, period_year: String(period_year), period_quarter: String(period_quarter),
    });
    return api.get(`/tax-reports/4df/xml?${params}`, { responseType: 'blob' }).then((r) => r.data);
  },
  getEsv: (organization_id: string, period_year: number, period_month: number) =>
    api.get<ESVData>('/tax-reports/esv/data', {
      params: { organization_id, period_year, period_month },
    }).then((r) => r.data),
  downloadEsvXml: (organization_id: string, period_year: number, period_month: number) => {
    const params = new URLSearchParams({
      organization_id, period_year: String(period_year), period_month: String(period_month),
    });
    return api.get(`/tax-reports/esv/xml?${params}`, { responseType: 'blob' }).then((r) => r.data);
  },
  getVatD1: (organization_id: string, period_year: number, period_month: number) =>
    api.get<VATD1Data>('/tax-reports/vat-d1/data', {
      params: { organization_id, period_year, period_month },
    }).then((r) => r.data),
  downloadVatD1Xml: (organization_id: string, period_year: number, period_month: number) => {
    const params = new URLSearchParams({
      organization_id, period_year: String(period_year), period_month: String(period_month),
    });
    return api.get(`/tax-reports/vat-d1/xml?${params}`, { responseType: 'blob' }).then((r) => r.data);
  },
};
